var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ListService, Pager } from './list.service';
var PagerComponent = /** @class */ (function (_super) {
    __extends(PagerComponent, _super);
    function PagerComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.pager = new Pager();
        _this.events = { page: 'page' };
        _this.clickable = true;
        return _this;
    }
    PagerComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        var params = this.component.params || {};
        this.groupName = this.service.getGroupName(params.groupName);
        this.saveQuery = this.service.setSaveQuery(this.groupName, params.saveQuery);
        this.clickable = this.action.validEvent(this.events.page);
        var page = 1;
        var cond = this.service.getCondition(this.groupName);
        if (typeof cond !== 'undefined' && this.saveQuery) {
            page = cond.page;
        }
        else {
            page = (params.initQuery && typeof params.initQuery.page !== 'undefined' ? params.initQuery.page : 1);
        }
        this.service.getQuery({ page: page }, this.groupName);
    };
    PagerComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    PagerComponent.prototype.onSubscribe = function (data) {
        this.pager = new Pager();
        if (typeof data !== 'undefined') {
            var query = this.service.getCurrentQuery(this.groupName);
            this.pager.last_page = data.totalPageCount;
            this.pager.current_page = query.page;
            if (data.totalPageCount > 0 && data.totalPageCount < query.page) {
                this.jump(data.totalPageCount);
            }
        }
    };
    PagerComponent.prototype.jump = function (page) {
        this.service.setBulkClear(this.groupName, false);
        this.service.getQuery({ page: page }, this.groupName);
        this.action.firstAction(this.events.page, { queryGroupName: this.groupName });
    };
    PagerComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    PagerComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'pager',
                    template: "<ul class=\"pager\" id=\"{{ componentName }}\" [class.pager-disabled]=\"!clickable\">\n  <!-- \uFF5C\uFF1C\uFF1C -->\n  <li class=\"pager_li\">\n    <a *ngIf=\"pager.current_page > 1\" class=\"pager_item pager_item-active\" href=\"javascript: void(0)\" (click)=\"jump(1)\">|&lt;&lt;</a>\n    <a *ngIf=\"pager.current_page <= 1\" class=\"pager_item pager_item-disabled\" href=\"javascript: void(0)\">|&lt;&lt;</a>\n  </li>\n\n  <!-- \uFF1C -->\n  <li class=\"pager_li\">\n    <a *ngIf=\"pager.current_page > 1\" class=\"pager_item pager_item-active\" href=\"javascript: void(0)\" (click)=\"jump(pager.current_page - 1)\">&lt;</a>\n    <a *ngIf=\"pager.current_page <= 1\" class=\"pager_item pager_item-disabled\" href=\"javascript: void(0)\">&lt;</a>\n  </li>\n\n  <!-- 1 -->\n  <li *ngIf=\"pager.current_page > 2\" class=\"pager_li\">\n    <a class=\"pager_item pager_item-active\" href=\"javascript: void(0)\" (click)=\"jump(1)\">1</a>\n  </li>\n\n  <!-- ... -->\n  <li *ngIf=\"pager.current_page > 3\" class=\"pager_li\">\n    <a class=\"pager_item pager_item-ellipsis\" href=\"javascript: void(0)\">...</a>\n  </li>\n\n  <li *ngIf=\"pager.current_page - 1 > 0\" class=\"pager_li\">\n    <a class=\"pager_item pager_item-active\" href=\"javascript: void(0)\" (click)=\"jump(pager.current_page - 1)\">{{ pager.current_page - 1 }}</a>\n  </li>\n  <li class=\"pager_li\">\n    <a class=\"pager_item pager_item-current\" href=\"javascript: void(0)\" (click)=\"jump(pager.current_page)\">{{ pager.current_page }}</a>\n  </li>\n  <li *ngIf=\"pager.current_page < pager.last_page\" class=\"pager_li\">\n    <a class=\"pager_item pager_item-active\" href=\"javascript: void(0)\" (click)=\"jump(pager.current_page + 1)\">{{ pager.current_page + 1 }}</a>\n  </li>\n\n  <!-- ... -->\n  <li *ngIf=\"pager.last_page - pager.current_page > 2\" class=\"pager_li\">\n    <a class=\"pager_item pager_item-ellipsis\" href=\"javascript: void(0)\">...</a>\n  </li>\n\n  <!-- last page -->\n  <li *ngIf=\"pager.last_page > pager.current_page + 1\" class=\"pager_li\">\n    <a class=\"pager_item pager_item-active\" href=\"javascript: void(0)\" (click)=\"jump(pager.last_page)\">{{ pager.last_page }}</a>\n  </li>\n\n  <!-- \uFF1E -->\n  <li class=\"pager_li\">\n    <a *ngIf=\"pager.last_page > pager.current_page\" class=\"pager_item pager_item-active\" href=\"javascript: void(0)\" (click)=\"jump(pager.current_page + 1)\">&gt;</a>\n    <a *ngIf=\"pager.last_page <= pager.current_page\" class=\"pager_item pager_item-disabled\" href=\"javascript: void(0)\">&gt;</a>\n  </li>\n\n  <!-- \uFF1E\uFF1E\uFF5C -->\n  <li class=\"pager_li\">\n    <a *ngIf=\"pager.last_page > pager.current_page\" class=\"pager_item pager_item-active\" href=\"javascript: void(0)\" (click)=\"jump(pager.last_page)\">&gt;&gt;|</a>\n    <a *ngIf=\"pager.last_page <= pager.current_page\" class=\"pager_item pager_item-disabled\" href=\"javascript: void(0)\">&gt;&gt;|</a>\n  </li>\n</ul>\n"
                }] }
    ];
    /** @nocollapse */
    PagerComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ListService }
    ]; };
    return PagerComponent;
}(ContentBaseComponent));
export { PagerComponent };
//# sourceMappingURL=pager.component.js.map